import React, { ChangeEvent, ChangeEventHandler } from "react";

import { Input } from "@chakra-ui/react";
import { TokensMap } from "../../hooks/useTokenBalances";
import { UseFormRegister } from "react-hook-form";

interface ITokenInput {
  name: string;
  value: string;
  isDisabled: boolean;
  placeholder: string;
  tokensMap: TokensMap;
  tokenSelectorKey: string;
  classNames?: {
    input?: string;
    button?: string;
  };
  onChange: (value: string) => void;
  register: UseFormRegister<any>;
}

const TokenInput: React.FC<ITokenInput> = ({
  name,
  value,
  isDisabled,
  placeholder,
  onChange,
  register,
}: ITokenInput) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const tokenAmountValidator = register(name);
  return (
    <>
      <Input
        borderRadius="0px"
        name={name}
        disabled={isDisabled}
        placeholder={placeholder}
        onChange={(e) => {
          tokenAmountValidator.onChange(e); // form validation
          onChange(e.target.value); // data passing
        }}
        onBlur={tokenAmountValidator.onBlur}
        ref={tokenAmountValidator.ref}
        value={value}
      />
      {/* <Button
        disabled={
          disabled || !tokens[(values as Record<string, any>)[tokenSelectorKey]]
        }
        className={classNames?.button}
        onClick={() => {
          setValue(
            tokens[(values as Record<string, any>)[tokenSelectorKey]].balance
          );
        }}
        variant="outline"
        type="button"
      >
        MAX
      </Button> */}
    </>
  );
};

export default TokenInput;
